import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Logger } from 'projects/common/src/app/classes';
import { IError } from 'projects/common/src/app/interfaces';
import { ILoginCredentials, ILogin } from '../interfaces';
import { AuthenticationService } from 'src/app/services/authentication';
import { environment } from 'src/environments/environment';
import { IRequestCancellable } from 'projects/common/src/app/interfaces/communication/request';
import { CommunicationSecurityService } from 'src/app/services/communication';
import { HubConnectionService } from '../../core/services/signal-r/hub-connection.service';
import { HubConnection } from '@aspnet/signalr';
import { UrlBuilderService } from 'projects/communication/src/app/services/url-builder.service';

@Injectable({
  providedIn: 'root',
})
export class LoginService extends Logger implements ILogin {
  private cancellable: IRequestCancellable;
  private rejectFn: (arg0: any) => void;
  private urlEndpoint = `${environment.securityBasePath}/account/login`;
  private hubLoginConnection: HubConnection | undefined;

  constructor(
    private communicationService: CommunicationSecurityService,
    private authService: AuthenticationService,
    private hubService: HubConnectionService,
    private urlBuilderService: UrlBuilderService,
  ) {
    super();
  }

  /**
   * Login
   */
  public login(data: ILoginCredentials): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.rejectFn = reject;
      this.cancellable = this.communicationService.postCancellable(this.urlEndpoint, {
        userName: data.username,
        password: data.password,
      });
      this.cancellable.source.subscribe(
        (response: any) => {
          this.authService.registerSession(response).then((result: boolean) => {
            resolve(result);
            location.reload(true);
          });
        },
        (error: HttpErrorResponse) => {
          reject(error);
        },
      );
    });
  }

  public cancel(): void {
    if (this.cancellable) {
      this.cancellable.cancel();
    }
    this.rejectFn({
      message: 'The request was cancelled',
      name: 'HttpErrorResponse',
    } as IError);
  }
}
